<button
  type="button"
  (click)="toggleTheme()"
  class="relative p-3 rounded-xl bg-gradient-to-br from-gray-100 to-gray-50 dark:from-white/10 dark:to-white/5 hover:from-gray-200 hover:to-gray-100 dark:hover:from-white/15 dark:hover:to-white/10 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary-500/50 dark:focus:ring-primary-600/50 active:scale-95 shadow-soft border border-gray-200/50 dark:border-white/10 touch-manipulation"
  aria-label="Toggle theme"
>
  <svg
    *ngIf="!isDarkMode"
    class="w-5 h-5 text-gray-700 dark:text-gray-300 transition-transform duration-300"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
    />
  </svg>
  <svg
    *ngIf="isDarkMode"
    class="w-5 h-5 text-luxury-gold dark:text-luxury-gold-light transition-transform duration-300"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
    />
  </svg>
</button>



